import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NgIf, NgClass } from '@angular/common';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
  selector: 'NiFormToggle',
  standalone: true,
  imports: [NgIf, NgClass, FormsModule], 
  templateUrl: './ni-toggle.component.html',
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => NiToggleComponent), multi: true }]
})

export class NiToggleComponent {
  @Input() label: string = '';
  @Input() labelOn: string = '';
  @Input() labelOff: string = '';
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Output() onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  handleChange(event: Event): void {
    if (this.disabled) {
      return;
    }

    this.checked = (event.target as HTMLInputElement).checked;
    this.onChange(this.checked);
    this.onToggle.emit(this.checked);
  }

  handleBlur(): void {
    this.onTouched();
  }
}
